module.exports = __webpack_public_path__ + "img/stats.3030d5e5.svg";